import { render, staticRenderFns } from "./insureList.vue?vue&type=template&id=33377bf1&scoped=true"
import script from "./insureList.vue?vue&type=script&lang=js"
export * from "./insureList.vue?vue&type=script&lang=js"
import style0 from "./insureList.vue?vue&type=style&index=0&id=33377bf1&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33377bf1",
  null
  
)

export default component.exports